import {Button, Dropdown, MenuProps} from "antd";
import useUserContext from "../../hooks/useUserContext";
import "./domainMenu.css";
import {DownOutlined} from "@ant-design/icons";
import useAppContext from "../../hooks/useAppContext";
import CreditModal from "../paymentsSection/CreditModal";
import {useState} from "react";
import useCredits from "../../hooks/useCredits";
import useGlobalModal from "../../hooks/useGlobalModal";

interface DomainMenuProps {
    isOutlined?: boolean;
}

const DomainMenu = ({ isOutlined = true }: DomainMenuProps) => {
    const { user, selectedDomain, actions: { setSelectedDomain } } = useUserContext();
    const { data: { shop } } = useAppContext();
    const domains = user?.shopDomains || [];
    const shops = user?.shops || [];
    const selectedShop = shops.find(shop => shop.name === selectedDomain);
    const { isPlanSupportCredits, allowedToPurchaseCredits, availableCredits } = useCredits();
    const { setIsCreditModalOpen } = useGlobalModal();

    const changeDomain = (domain: string) => {
        setSelectedDomain(domain);
        localStorage.setItem('selectedDomain', domain);
    }

    const items: MenuProps['items'] = [
        ...(isPlanSupportCredits || availableCredits ? [{
            key: 'creditsLeft',
            label: <div className="credit-balance-container">
                    <div>Credits</div>
                    <div>{availableCredits || 0}</div>
                </div>,
            className: "no-hover",
        }, ...(allowedToPurchaseCredits ? [{
            key: 'purchaseCredits',
            label: 'Get more credits',
            onClick: () => setIsCreditModalOpen(true),
        }] : [])] : []),
        ...(domains?.length ? [{
            key: 'switchShop',
            label: 'Switch shop',
            children: [
                ...shops.map(shop => ({
                    key: shop.name,
                    label: (
                        <a onClick={() => changeDomain(shop.name)}>
                            {shop.friendlyName || shop.name}
                        </a>
                    ),
                }))
            ]
        }] : [])
    ]

    if(!user) return null;
    if(!domains?.length && !isPlanSupportCredits) {
        return <Button className={`domain-button-label ${isOutlined ? 'outlined' : ''}`} icon={<DownOutlined />}>{selectedShop?.friendlyName || selectedDomain || ''}</Button>;
    }

    return <>
        <Dropdown menu={{ items }} placement="bottomRight" >
            <Button className={`domain-button-label ${isOutlined ? 'outlined' : ''}`} icon={<DownOutlined />}>{selectedShop?.friendlyName || selectedDomain || ''}</Button>
        </Dropdown>
    </>
}

export default DomainMenu;